<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div>
    <v-container bg fluid>
      <v-layout class="justify-start" row></v-layout>
      <v-row class="mt-0 pa-0">
        <iframe id="report_html" class="pa-0"></iframe>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: 'p_c_snapshot_report',
  props: {
    loading: Boolean,
    update: [Boolean, Number],
  },

  data: () => ({
    report_html: '',
  }),

  mounted: function () {
  },

  watch: {},

  computed: {
    ...mapGetters(['getDsmAppState', 'app_data']),
  },
  methods: {},
};
</script>

<style scoped>
iframe {
  width: 100%;
  height: 70vh;

  border-width: 0;
}

.report-button {
  background-color: green;
}
</style>
